import { render, staticRenderFns } from "./OSheetReceiptComp.vue?vue&type=template&id=aa364d18&"
import script from "./OSheetReceiptComp.vue?vue&type=script&lang=js&"
export * from "./OSheetReceiptComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VSpacer})
